// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface GoogleplusIconSignature {
  Element: SVGSVGElement;
}

export const GoogleplusIcon: TOC<GoogleplusIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.9 13.6V10.9V10.7H14.6V12C14.6 15.7 11.5 18.8 7.8 18.8C4.1 18.8 1 15.7 1 12C1 8.29995 4.1 5.19995 7.8 5.19995C9.5 5.19995 11.1 5.69995 12.3 6.79995L10.5 8.89995C9.9 8.19995 8.9 7.89995 7.9 7.89995C5.6 7.89995 3.7 9.79995 3.7 12.1C3.7 14.4 5.6 16.3 7.9 16.3C9.6 16.3 11.2 15.2 11.7 13.6H7.9ZM20.3 8.09995V10.9H23V12.3H20.3V15H18.8V12.3H16.2V10.9H18.8V8.09995H20.3Z"/>
</svg>
</template>;